import React, { useState, useEffect } from "react";
import { MdLightMode, MdDarkMode } from "react-icons/md";

const ThemeToggle = () => {
  // Inicializar con la preferencia guardada o tema claro por defecto
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === null) {
      localStorage.setItem("theme", "light");
      return false;
    }
    return savedTheme === "dark";
  });

  useEffect(() => {
    // Aplicar clase CSS al body según el tema
    if (isDarkMode) {
      document.body.classList.add("dark-theme");
      document.body.classList.remove("light-theme");
    } else {
      document.body.classList.add("light-theme");
      document.body.classList.remove("dark-theme");
    }

    // Guardar preferencia en localStorage
    localStorage.setItem("theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  // Efecto para aplicar tema claro por defecto en la primera carga
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === null || savedTheme === "light") {
      document.body.classList.add("light-theme");
      document.body.classList.remove("dark-theme");
    }
  }, []);

  const toggleTheme = () => {
    setIsDarkMode((prev) => !prev);
  };

  return (
    <button
      onClick={toggleTheme}
      style={{
        backgroundColor: "var(--bg-secondary)",
        border: "1px solid var(--border-color)",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all 0.3s ease",
        boxShadow: "0 2px 4px var(--shadow-color)",
        color: "var(--text-primary)",
        fontSize: "15px",
      }}
      title={`Cambiar a tema ${isDarkMode ? "claro" : "oscuro"}`}
      aria-label={`Cambiar a tema ${isDarkMode ? "claro" : "oscuro"}`}
    >
      {isDarkMode ? <MdLightMode /> : <MdDarkMode />}
    </button>
  );
};

export default ThemeToggle;
